export interface AdfNode extends Record<string, any> {
    type: string;
    parent?: AdfNode;
    content?: AdfNode[];
    attrs?: Record<string, any>;
    marks?: AdfMark[];
    text?: string;
}

export interface AdfMark {
    type: string;
    attrs?: Record<string, any>;
}

export interface AdfDoc {
    jiraIssueId?: string;
    type: 'doc';
    version: number;
    content: AdfNode[];
}

export interface AdfNodeProps {
    node: AdfNode;
}

const treeify = (node: AdfNode) => {
    for (const child of node?.content ?? []) {
        child.parent = node;
        treeify(child);
    }
    return node;
};

export const AdfDoc = Object.freeze({
    create: (content: AdfNode[], shouldTreeify = false) => {
        return {
            content: shouldTreeify ? content.map(treeify) : content,
            type: 'doc',
            version: 1,
        };
    },
});
